import { React } from 'react';

const Footer = ({changeFooter}) => {

  let d = new Date();
  return (
    <div className={`footer ${changeFooter}`}>
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a style={{color:"#f60f14"}} href="https://www.magpiebyte.com/" target="_blank" rel="noreferrer">
            Magpie
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
